import styled, {css} from 'styled-components';

import {colors, breakpoint} from 'theme';

export const Wrapper = styled.div<{noPaddings?: boolean}>`
    display: flex;
    flex-flow: column nowrap;
    flex: 1;
    ${(p) =>
        !p.noPaddings &&
        css`
            padding: 10px 15px 15px 15px;
        `}
    background-color: ${colors.white};
    border-radius: 8px;

    &.half-width-content-container {
        max-width: 100%;
    }

    @media (min-width: ${breakpoint.tablet}) {
        ${(p) =>
            !p.noPaddings &&
            css`
                padding: 15px 30px 30px 30px;
            `}

        &.half-width-content-container {
            max-width: 50%;
        }
    }
`;

export const Content = styled.div`
    max-width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
`;

export const CenterContainer = styled.div`
    min-height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const ErrorHeading = styled.h1`
    margin: 0;
`;
